import { appendSearchParams } from '../../utils/utils';

(function () {
    'use strict';

    angular.module('app', ["ngStorage", "ngCookies", "ui.filters"]).controller('myProfileController', myProfileController);
    angular.module('app').directive('numberLimit', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    var transformedInput = text.replace(/[^0-9]/g, '');
                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    });

    myProfileController.$inject = [
        "$scope",
        "$sessionStorage",
        "$timeout",
        "policyHolderService",
        "userService",
        "policiesService",
        "juiceWebApiService",
    ];

    function myProfileController(
        $scope,
        $sessionStorage,
        $timeout,
        policyHolderService,
        userService,
        policiesService,
        juiceWebApiService) {

        var vm = this;

        vm.loadingProfile = true;
        vm.memberIsLoggedOn = memberIsLoggedOn;
        vm.getPhoneTypesOrder = getPhoneTypesOrder;
        vm.isUserExpried = false;
        vm.isIndividual = true;
        vm.isMultiplePH = false;
        vm.policyholder = null;
        vm.showAddressChangeForm = false;
        vm.showModalAmendPolicy = false;
        vm.showModalRequestUpdate = false;
        vm.showAlertSuccess = false;
        vm.showAlertFailed = false;
        vm.showSpinner = false;
        vm.address = {
            houseNameOrNumber: '',
            line1: '',
            line2: '',
            line3: '',
            line4: '',
            postcode: '',
        };
        vm.showAddressSuggestions = false;
        vm.addressSuggestions = [];
        vm.countActivePoliciesAddressRatingFactor = -1;

        loadData();

        async function loadData() {
            getSessionIdFromUrl();
            var sessionId = JSON.parse(sessionStorage.getItem("ngStorage-sessionId"));
            if (!sessionId) {
                return;
            }

            if ($sessionStorage.phoneNumberUpdateSuccess != null) {
                triggerAlert($sessionStorage.phoneNumberUpdateSuccess, 'phoneUpdate');
                delete $sessionStorage.phoneNumberUpdateSuccess;
            }

            await userService.getSession(sessionId)
                .then(async function (result) {
                    if (result) {
                        await getPolicyHolderBySessionId(sessionId, result.data).then(function (policyholder) {
                            vm.policyholder = policyholder;
                        });
                    } else {
                        vm.isUserExpried = true;
                    }
                })
                .catch(() => {
                    triggerAlert(false);
                })
                .finally(() => {
                    vm.loadingProfile = false;
                });
        }

        function memberIsLoggedOn() {
            return userService.memberIsLoggedOn();
        }

        function getSessionIdFromUrl() {
            const params = new URLSearchParams(window.location.search);
            const sessionId = params.get('sid');
            if (sessionId) {
                sessionStorage.setItem("ngStorage-sessionId", JSON.stringify(sessionId));
            }
        }

        async function getPolicyHolderBySessionId(sessionId, session) {

            const memberId = session.memberId;

            vm.membershipId = memberId;

            return await userService.getPolicyHolderBySessionId(sessionId)
                .then(function (result) {
                    if (result && result.data) {
                        return handlePolicyholderData(result.data);
                    }
                })
                .catch(async function () {
                    return await getBrandApiMember(memberId).then(function (brandApiPolicyholder) {
                        return brandApiPolicyholder;
                    });
                });
        }

        function handlePolicyholderData(data) {
            if (!Array.isArray(data) || data.length === 0) {
                return;
            }

            if (data.length > 1) {
                vm.isMultiplePH = true;
                return;
            }

            const policyholder = data[0];
            vm.isIndividual = policyholder?.type?.toLocaleLowerCase() === "individual";

            var policies = policyholder.activePolicies;
            vm.ativePolicies = policies.filter(policy => Array.isArray(policy.statuses) && policy.statuses.includes('Active'));

            if (vm.ativePolicies.length > 0) {
                var ativePoliciesAddressRatingFactor = policies.filter(policy => Array.isArray(policy.statuses) && policy.statuses.includes('Active') && policy.ratesOnPolicyholderAddress);

                vm.countActivePoliciesAddressRatingFactor = ativePoliciesAddressRatingFactor.length;

                if (vm.countActivePoliciesAddressRatingFactor == 1) {
                    vm.policyAddressRatingFactor = ativePoliciesAddressRatingFactor[0];
                }
            }
            else {
                vm.countActivePoliciesAddressRatingFactor = -1;
            }

            return {
                title: policyholder.title,
                forename: policyholder.forename,
                surname: policyholder.surname,
                dateOfBirth: policyholder.dateOfBirth,
                email: policyholder.emailAddress,
                telephoneNumbers: Array.isArray(policyholder.telephoneNumbers) ? policyholder.telephoneNumbers : [],
                companyType: policyholder.companyType,
                tradingName: policyholder.tradingName,
                partnerNames: policyholder.partnerNames,
                addressUpdate: policyholder.addressUpdate,
                addressUpdatesPermitted: policyholder.addressUpdatesPermitted,
                addressUpdatesByMta: policyholder.addressUpdatesByMta,
                address: Array.isArray(policyholder.addresses) && policyholder.addresses.length > 0 ? policyholder.addresses[0] : null,
                fiduciaries: Array.isArray(policyholder.fiduciaries) ? policyholder.fiduciaries : [],
            }
        }

        function getPhoneTypesOrder(phoneNo) {
            const priority = ["mobile", "home", "work", "other"];
            return priority.indexOf(phoneNo.type.toLowerCase());
        };

        function canAmendAddressByMta(policy) {
            return !!(policy?.mta?.mtaEnabled && policy?.mta?.websiteMtaUri && !isFlexTourerPolicy(policy));
        }

        function isFlexTourerPolicy(policy) {
            return policyMatchesAny([
                policy?.productType,
                policy?.productTypeDisplayName,
                policy?.productDisplayName,
                policy?.line?.productTypeDisplayName,
                policy?.line?.displayName,
                policy?.line?.productDisplayName,
                policy?.renewal?.quote?.provider?.targetRuleSetName,
                policy?.renewal?.quote?.provider?.targetProductName,
                policy?.renewal?.quote?.provider?.displayName,
                policy?.renewal?.quote?.provider?.code
            ], 'flex');
        }

        function getMtaJourneyUri(uri) {
            if (!uri) return uri;
            return uri.split('#')[0] + '#!/mta/amend-policy';
        }

        function policyMatchesAny(values, expected) {
            const expectedKey = normalisePolicyText(expected);
            return values.some(function (value) {
                const key = normalisePolicyText(value);
                return key === expectedKey || key.indexOf(expectedKey) !== -1;
            });
        }

        function normalisePolicyText(value) {
            return (value || '').toString().toLowerCase().replace(/[^a-z0-9]/g, '');
        }

        function updateTopNavUsername(forename) {
            const topNavElement = document.getElementById('topNavUserName');
            if (topNavElement && forename) {
                topNavElement.textContent = "Hello " + decodeURIComponent(forename);
            }
        }

        function getBrandApiMember(membershipId) {

            return policyHolderService.getMember(membershipId)
                .then(function (brandApiPolicyholder) {
                    var policyholder = fromBrandApiPolicyholder(brandApiPolicyholder);
                    policyholder.policies = fromBrandApiPolicies(brandApiPolicyholder.Policies);
                    return policyholder;
                });
        }

        function fromBrandApiPolicyholder(policyholder) {
            return {
                id: policyholder.Id,
                email: policyholder.Email,
                title: policyholder.Title,
                forename: policyholder.Forename,
                surname: policyholder.Surname
            };
        }

        function fromBrandApiPolicies(policies) {
            return policies.map(fromBrandApiPolicy);
        }

        function fromBrandApiPolicy(policy) {
            var iconFilename = policy.Line.Description + '.svg';
            if (policy.Line.Id == 27) {
                iconFilename = 'small-business.svg';
            }

            return {
                brandApiPolicy: true,
                id: policy.Id,
                number: policy.Number,
                policyHash: policy.PolicyHash,
                startDate: policy.StartDate,
                endDate: policy.EndDate,
                predecessorId: policy.PredecessorId,
                cardId: policy.Payment.CardId,
                bankId: policy.Payment.BankId,
                paymentId: policy.Payment.Id,
                line: {
                    id: policy.Line.Id,
                    description: policy.Line.Description,
                    displayName: policy.Line.Description,
                    email: policy.Line.Email,
                    telNo: policy.Line.TelNo,
                    address: policy.Line.Address,
                    iconName: iconFilename,
                    productDisplayName: policy.Line.Description
                },
                renewal: {
                    isDisabled: policy.Payment.Id == 12,
                    autoRenewalOptOut: policy.Renewal.AutoRenewalOptOut,
                    autoRenewalOptOutDisabled: policy.Renewal.AutoRenewalOptOutDisabled,
                    autoRenewalOptOutConfirmed: policy.Renewal.AutoRenewalOptOut,
                },
                statuses: policy.statuses
            };
        }

        vm.handleEditDetails = function () {
            $sessionStorage.telephoneNumbers = vm.policyholder.telephoneNumbers;
            window.location.href = '/my-profile/edit-details';
        }

        vm.cancel = function () {
            vm.address = {};
            $scope.vm.addressForm.$setPristine();
            $scope.vm.addressForm.$setUntouched();
        };

        let addressTimeout;

        vm.onAddressInputChange = function () {
            const searchAddress = vm.searchAddress;

            if (addressTimeout) clearTimeout(addressTimeout);

            if (searchAddress && searchAddress.length >= 1) {
                // Debounce 300ms
                addressTimeout = setTimeout(() => {
                    juiceWebApiService.searchAddress(searchAddress).then(function (response) {
                        vm.addressSuggestions = response;
                        vm.showAddressSuggestions = true;
                    });
                }, 300);
            } else {
                vm.addressSuggestions = [];
                vm.showAddressSuggestions = false;
            }
        };

        vm.selectAddressSuggestion = function (addressID) {
            vm.searchAddress = null;
            vm.addressSuggestions = [];
            vm.showAddressSuggestions = false;

            juiceWebApiService.getAddress(addressID).then(function (response) {
                handleAddress(response);
            });
        };

        function handleAddress(fullAddress) {
            let addressHolder = JSON.parse(JSON.stringify(vm.address));

            if (fullAddress) {
                if (fullAddress.buildingNumber !== '' || fullAddress.buildingName !== '' || fullAddress.company !== '') {
                    if (fullAddress.line2.indexOf(fullAddress.buildingNumber) !== -1) {
                        addressHolder.houseNameOrNumber = `${fullAddress.company} ${fullAddress.buildingName}`.trim();
                        addressHolder.line1 = fullAddress.street !== '' ? `${fullAddress.buildingNumber} ${fullAddress.street}` : fullAddress.line1;
                    } else {
                        addressHolder.houseNameOrNumber = `${fullAddress.company} ${fullAddress.buildingNumber} ${fullAddress.buildingName}`.trim();
                        addressHolder.line1 = fullAddress.street !== '' ? fullAddress.street : fullAddress.line1;
                    }

                    fullAddress.line2 = fullAddress.line2.replace(fullAddress.street, '').replace(fullAddress.buildingNumber, '').trim();

                    if (fullAddress.buildingName.indexOf(fullAddress.line2) !== -1) {
                        fullAddress.line2 = '';
                    }

                    if (fullAddress.line2 !== '') {
                        addressHolder.line2 = fullAddress.line2;
                        addressHolder.line3 = fullAddress.line3;
                        addressHolder.line4 = fullAddress.line4;
                        addressHolder.postcode = fullAddress.postcode;
                    } else if (fullAddress.line1 === '' && fullAddress.line2 === '') {
                        addressHolder.line1 = addressHolder.houseNameOrNumber;
                        addressHolder.line2 = fullAddress.line3;
                        addressHolder.line3 = fullAddress.line4;
                        addressHolder.line4 = 'United Kingdom';
                        addressHolder.postcode = fullAddress.postcode;
                    } else {
                        addressHolder.line2 = fullAddress.line3;
                        addressHolder.line3 = fullAddress.line4;
                        addressHolder.line4 = 'United Kingdom';
                        addressHolder.postcode = fullAddress.postcode;
                    }
                } else {
                    addressHolder.houseNameOrNumber = fullAddress.line1;
                    addressHolder.line1 = fullAddress.street;
                    addressHolder.line2 = fullAddress.line2;
                    addressHolder.line3 = fullAddress.line3;
                    addressHolder.line4 = fullAddress.line4;
                    addressHolder.postcode = fullAddress.postcode;
                }

                vm.address = addressHolder;
            }
        }

        vm.onAddressBlur = function () {
            setTimeout(() => {
                vm.showAddressSuggestions = false;
            }, 200);
        };

        vm.onAddressFocus = function () {
            if (vm.addressSuggestions.length) {
                vm.showAddressSuggestions = true;
            }
        };

        vm.toggleAddressChangeForm = function (status) {
            vm.showAddressChangeForm = status;
            scrollPageToTop();
        }

        vm.toggleModalAmendPolicy = function (status) {
            vm.showModalAmendPolicy = status;
            if (status) {
                scrollPageToTop();
            }
        }

        vm.toggleModalRequestUpdate = function (status) {
            vm.showModalRequestUpdate = status;
            if (status) {
                scrollPageToTop();
            }
        }

        vm.toggleVoucherResendModal = function (status) {
            vm.showVoucherResendModal = status;
            if (status) {
                scrollPageToTop();
            }
        }

        vm.toggleVoucherResendModal = function (status) {
            vm.showVoucherResendModal = status;
        }

        vm.handleBeforeUpdateAddress = function () {
            const count = vm.countActivePoliciesAddressRatingFactor;
            const currentAddress = vm.policyholder.address;
            const address = {
                houseNameOrNumber: currentAddress.houseNameOrNumber || '',
                line1: currentAddress.address1 || '',
                line2: currentAddress.address2 || '',
                line3: currentAddress.address3 || '',
                line4: currentAddress.address4 || '',
                postcode: currentAddress.postcode || '',
            };

            switch (true) {
                case count < 0:
                    return;
                case count == 0:
                    if (vm.policyholder.addressUpdatesPermitted) {
                        vm.address = address;
                        vm.toggleAddressChangeForm(true);
                    }
                    return;
                case count == 1:
                    if (vm.policyholder.addressUpdatesPermitted && (!vm.policyholder.addressUpdatesByMta || isFlexTourerPolicy(vm.policyAddressRatingFactor))) {
                        vm.address = address;
                        vm.toggleAddressChangeForm(true);
                    }
                    else if (vm.policyholder.addressUpdatesByMta && canAmendAddressByMta(vm.policyAddressRatingFactor)) {
                        vm.toggleModalAmendPolicy(true);
                    }
                    else {
                        vm.toggleModalRequestUpdate(true);
                    }
                    return;
                case count > 1:
                    vm.toggleModalRequestUpdate(true);
                    return;
            }
        }

        vm.submitAddressChange = async function () {
            if ($scope.vm.addressForm.$valid && vm.policyholder.addressUpdatesPermitted) {
                const request = {
                    Address: {
                        HouseNameOrNumber: vm.address.houseNameOrNumber,
                        Address1: vm.address.line1,
                        Address2: vm.address.line2,
                        Address3: vm.address.line3,
                        Address4: vm.address.line4,
                        Postcode: vm.address.postcode,
                        RequestUpdate: true,
                    }
                };
                vm.showSpinner = true;
                const sessionId = JSON.parse(sessionStorage.getItem("ngStorage-sessionId"));

                await userService
                    .updatePolicyHolderBySessionId(sessionId, request)
                    .then((response) => {
                        if (response.status == 204) {
                            vm.policyholder.address = {
                                houseNameOrNumber: vm.address.houseNameOrNumber,
                                address1: vm.address.line1,
                                address2: vm.address.line2,
                                address3: vm.address.line3,
                                address4: vm.address.line4,
                                postcode: vm.address.postcode
                            }
                            vm.toggleAddressChangeForm(false);
                            triggerAlert(true);
                        }
                        else {
                            triggerAlert(false);
                        }
                    })
                    .catch(() => {
                        triggerAlert(false);
                    })
                    .finally(() => {
                        vm.showSpinner = false;
                    });
            }
        };

        function triggerAlert(isSuccess, messageType = 'addressUpdate') {
            vm.showAlertSuccess = isSuccess;
            vm.showAlertFailed = !isSuccess;

            switch (messageType) {
                case 'phoneUpdate':
                    vm.successMessage = 'Your phone number has been updated successfully!';
                    vm.errorMessage = 'Error updating phone numbers!';
                    break;
                case 'addressUpdate':
                    vm.successMessage = 'Your address has been updated successfully!';
                    vm.errorMessage = 'An error has occurred, please contact support!';
                    break;
                default:
                    vm.successMessage = 'Success!';
                    vm.errorMessage = 'Failed!';
                    break;
            }

            $timeout(function () {
                vm.showAlertSuccess = false;
                vm.showAlertFailed = false;
            }, 4000);
        };

        vm.amendPolicy = async function () {
            if (!vm.policyholder.addressUpdatesByMta || !canAmendAddressByMta(vm.policyAddressRatingFactor)) {
                triggerAlert(false);
                vm.toggleModalAmendPolicy(false);
                return;
            }

            $sessionStorage.caravansPolicy = null;
            $sessionStorage.caravansPolicyholder = null;
            $sessionStorage.valuablesPolicy = null;
            $sessionStorage.valuablesPolicyholder = null;
            $sessionStorage.parkhomesPolicy = null;
            $sessionStorage.parkhomesPolicyholder = null;
            $sessionStorage.IsMta = true;

            vm.showSpinner = true;
            await policiesService
                .createQuote(vm.policyAddressRatingFactor.policyNumber)
                .then(function (convertQuoteResponse) {
                    if (convertQuoteResponse?.data?.quoteId && vm.policyAddressRatingFactor?.mta?.websiteMtaUri) {
                        window.location = appendSearchParams(getMtaJourneyUri(vm.policyAddressRatingFactor.mta.websiteMtaUri), {
                            quoteid: convertQuoteResponse.data.quoteId,
                            updateAddress: vm.ativePolicies.length === 1,
                        });
                    }
                    else {
                        triggerAlert(false);
                    }
                })
                .catch(() => {
                    triggerAlert(false);
                })
                .finally(() => {
                    vm.showSpinner = false;
                    vm.toggleModalAmendPolicy(false);
                });
        };

        vm.redirectToContactUs = function () {
            vm.toggleModalRequestUpdate(false);
            window.open('https://help.ripeinsurance.co.uk/hc/en-gb/requests/new?ticket_form_id=11884067899677', '_blank');
        }

        vm.resendAffordableGolfVoucher = resendAffordableGolfVoucher;

        function resendAffordableGolfVoucher() {
            console.log('Active policies:', vm.ativePolicies);
            const golfPolicy = vm.ativePolicies.find(policy => {
                console.log('Checking policy:', policy);
                return policy.productName === 'GolfCare';
            });
            console.log('Found golf policy:', golfPolicy);
            if (!golfPolicy) {
                console.log('No GolfCare policy found');
                triggerAlert(false, 'resendVoucher');
                return;
            }
            vm.showSpinner = true;
            const sessionId = JSON.parse(sessionStorage.getItem("ngStorage-sessionId"));
            console.log('Session ID:', sessionId);
            console.log('Policy number:', golfPolicy.policyNumber);

            userService.resendAffordableGolfVoucher(sessionId, golfPolicy.policyNumber)
                .then((result) => {
                    console.log('Resend success:', result);
                    vm.showSpinner = false;
                    vm.toggleVoucherResendModal(true);
                })
                .catch((error) => {
                    console.log('Resend error:', error);
                    triggerAlert(false, 'resendVoucher');
                    vm.showSpinner = false;
                })
                .finally(() => {
                    vm.showSpinner = false;
                });
        }

        vm.goBack = function () {
            window.history.back();
        }

        function scrollPageToTop() {
            $timeout(function () {
                if (typeof window === 'undefined') {
                    return;
                }

                window.scrollTo(0, 0);

                if (document && document.documentElement) {
                    document.documentElement.scrollTop = 0;
                }

                if (document && document.body) {
                    document.body.scrollTop = 0;
                }
            }, 0, false);
        }
    }
})()
